/* Fantastick V8.4.0 – visual choices and optional return to the static preview.
   Native select values/events remain the data interface; no product state is duplicated. */
(function () {
  "use strict";
  var VERSION = "8.4.0";
  if (window.FantastickConfiguratorControls && window.FantastickConfiguratorControls.version === VERSION) return;
  var sequence = 0;

  function node(tag, className, text) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    if (text !== undefined) el.textContent = text;
    return el;
  }
  function number(value, fallback, min, max) {
    var n = Number(value);
    return Math.max(min, Math.min(max, value === undefined || value === null || !Number.isFinite(n) ? fallback : n));
  }
  function icon(kind) {
    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    var path = document.createElementNS(svg.namespaceURI, "path");
    svg.setAttribute("viewBox", "0 0 24 24");
    svg.setAttribute("aria-hidden", "true");
    svg.setAttribute("focusable", "false");
    path.setAttribute("d", kind === "up" ? "M12 19V5m-6 6 6-6 6 6" : kind === "check" ? "m5 12 4 4L19 6" : "m6 9 6 6 6-6");
    path.setAttribute("fill", "none");
    path.setAttribute("stroke", "currentColor");
    path.setAttribute("stroke-width", "2");
    path.setAttribute("stroke-linecap", "round");
    path.setAttribute("stroke-linejoin", "round");
    svg.appendChild(path);
    return svg;
  }
  function fontStyle(el, font) {
    el.style.fontFamily = font.family;
    el.style.fontWeight = font.weight || "400";
    el.style.fontStyle = font.style || "normal";
  }
  function fold(value) {
    return String(value || "").trim().toLocaleLowerCase("de");
  }

  function Controls(instance) {
    this.i = instance;
    this.root = instance.root;
    this.settings = instance.config.controlsUI || {};
    this.fonts = [];
    this.colors = [];
    this.removers = [];
    this.observers = [];
    this.frame = 0;
    this.dead = false;
    this.returnVisible = false;
    this.uid = "fkc-choice-" + (++sequence);
    this.root.style.setProperty("--fkc-font-preview-size", number(this.settings.fontSize, 22, 16, 32) + "px");
    this.root.style.setProperty("--fkc-font-list-height", number(this.settings.fontListHeight, 280, 160, 400) + "px");
    this.root.style.setProperty("--fkc-thread-swatch-size", number(this.settings.swatchSize, 30, 24, 48) + "px");
    this.root.style.setProperty("--fkc-choice-accent", this.settings.selectionColor || "#202124");
    instance.elements.fontSelects.forEach(function (select, index) {
      if (this.settings.fontDisplay !== "native") this.makeFont(select, index);
    }, this);
    instance.elements.colorSelects.forEach(function (select, index) {
      if (this.settings.colorDisplay !== "native") this.makeColor(select, index);
    }, this);
    this.root.classList.toggle("fkc--visual-choices", Boolean(this.fonts.length || this.colors.length));
    this.listen(document, "pointerdown", function (event) {
      this.fonts.forEach(function (picker) {
        if (picker.open && !picker.wrap.contains(event.target)) this.closeFont(picker, false);
      }, this);
    }.bind(this));
    this.listen(document, "focusin", function (event) {
      this.fonts.forEach(function (picker) {
        if (picker.open && !picker.wrap.contains(event.target)) this.closeFont(picker, false);
      }, this);
    }.bind(this));
    this.makeReturn();
    this.bindGeometry();
    this.sync();
  }

  Controls.prototype.listen = function (target, type, callback, options) {
    if (!target || !target.addEventListener) return;
    target.addEventListener(type, callback, options);
    this.removers.push(function () { target.removeEventListener(type, callback, options); });
  };
  Controls.prototype.enhance = function (select, wrap, target, labelId) {
    var label = select.labels && select.labels[0];
    if (!label) label = Array.from(this.root.querySelectorAll("label")).find(function (item) { return item.htmlFor === select.id; });
    var previous = { hidden: select.hidden, tabindex: select.getAttribute("tabindex"), aria: select.getAttribute("aria-hidden"), labelFor: label && label.htmlFor, labelId: label && label.getAttribute("id") };
    if (label) {
      if (!label.id) label.id = labelId;
      label.htmlFor = target.id;
    }
    select.insertAdjacentElement("afterend", wrap);
    select.hidden = true;
    select.setAttribute("aria-hidden", "true");
    select.tabIndex = -1;
    this.removers.push(function () {
      wrap.remove();
      select.hidden = previous.hidden;
      ["tabindex", "aria-hidden"].forEach(function (attribute, index) {
        var value = index ? previous.aria : previous.tabindex;
        if (value === null) select.removeAttribute(attribute); else select.setAttribute(attribute, value);
      });
      if (label) {
        label.htmlFor = previous.labelFor;
        if (previous.labelId === null) label.removeAttribute("id"); else label.id = previous.labelId;
      }
    });
    return label;
  };
  Controls.prototype.commit = function (select, key) {
    if (this.i.busy || select.disabled || select.value === key) return;
    select.value = key;
    select.dispatchEvent(new Event("change", { bubbles: true }));
    this.sync();
  };
  Controls.prototype.sample = function (key) {
    if (this.settings.fontSampleMode === "name" || !this.settings.fontSampleMode) return "";
    if (this.settings.fontSampleMode === "text") {
      var text = String(this.i.state.textValues[key] || "").trim();
      if (text) return text;
    }
    return String(this.settings.fontSampleText || "Mia & Noah");
  };
  Controls.prototype.makeFont = function (select, index) {
    var id = this.uid + "-font-" + index;
    var wrap = node("div", "fkc__font-picker");
    var trigger = node("button", "fkc__font-trigger");
    var current = node("span", "fkc__font-current");
    var name = node("span", "fkc__font-name");
    var sample = node("span", "fkc__font-sample");
    var list = node("div", "fkc__font-list");
    trigger.type = "button";
    trigger.id = id + "-trigger";
    trigger.setAttribute("aria-haspopup", "listbox");
    trigger.setAttribute("aria-expanded", "false");
    trigger.setAttribute("aria-controls", id + "-list");
    name.id = id + "-current";
    current.append(name, sample);
    trigger.append(current, icon("down"));
    list.id = id + "-list";
    list.setAttribute("role", "listbox");
    list.hidden = true;
    var picker = { select: select, wrap: wrap, trigger: trigger, name: name, sample: sample, list: list, options: [], open: false, active: 0, typeahead: "", typeTimer: 0 };
    this.i.fonts.forEach(function (font, n) {
      var option = node("button", "fkc__font-option");
      var title = node("span", "fkc__font-name", font.name);
      var example = node("span", "fkc__font-sample");
      var tick = icon("check");
      option.type = "button";
      option.id = id + "-option-" + n;
      option.dataset.fkcFontChoice = font.key;
      option.setAttribute("role", "option");
      option.setAttribute("aria-selected", "false");
      option.setAttribute("aria-label", font.name);
      option.tabIndex = -1;
      fontStyle(title, font);
      fontStyle(example, font);
      option.append(title, example, tick);
      list.appendChild(option);
      picker.options.push({ el: option, sample: example, font: font });
    });
    wrap.append(trigger, list);
    var label = this.enhance(select, wrap, trigger, id + "-label");
    if (label) {
      trigger.setAttribute("aria-labelledby", label.id + " " + name.id);
      list.setAttribute("aria-labelledby", label.id);
    } else { trigger.setAttribute("aria-label", "Schriftart auswählen"); list.setAttribute("aria-label", "Schriftart"); }
    this.fonts.push(picker);
    this.listen(trigger, "click", function () {
      if (picker.open) this.closeFont(picker, true); else this.openFont(picker);
    }.bind(this));
    this.listen(trigger, "keydown", function (event) {
      if (event.key === "ArrowDown" || event.key === "ArrowUp") {
        event.preventDefault();
        this.openFont(picker);
      } else if (event.key === "Escape") this.closeFont(picker, true);
    }.bind(this));
    this.listen(list, "click", function (event) {
      var option = event.target.closest("[data-fkc-font-choice]");
      if (!option || option.disabled) return;
      this.commit(select, option.dataset.fkcFontChoice);
      this.closeFont(picker, true);
    }.bind(this));
    this.listen(list, "keydown", function (event) { this.fontKey(picker, event); }.bind(this));
  };
  Controls.prototype.openFont = function (picker) {
    if (this.i.busy || picker.select.disabled) return;
    this.closeFonts(false);
    picker.open = true;
    picker.list.hidden = false;
    picker.trigger.setAttribute("aria-expanded", "true");
    picker.wrap.classList.add("is-open");
    var selected = picker.options.findIndex(function (option) { return option.font.key === picker.select.value; });
    this.focusFont(picker, Math.max(0, selected));
    this.schedule();
  };
  Controls.prototype.focusFont = function (picker, index) {
    picker.active = (index + picker.options.length) % picker.options.length;
    picker.options.forEach(function (option, n) { option.el.tabIndex = n === picker.active && picker.open ? 0 : -1; });
    var active = picker.options[picker.active].el;
    active.focus({ preventScroll: true });
    // Scroll only the list, never the whole page under the sticky preview.
    var box = active.getBoundingClientRect(), bounds = picker.list.getBoundingClientRect();
    if (box.top < bounds.top) picker.list.scrollTop -= bounds.top - box.top;
    else if (box.bottom > bounds.bottom) picker.list.scrollTop += box.bottom - bounds.bottom;
  };
  Controls.prototype.closeFont = function (picker, restoreFocus) {
    if (!picker.open) return;
    picker.open = false;
    picker.list.hidden = true;
    picker.trigger.setAttribute("aria-expanded", "false");
    picker.wrap.classList.remove("is-open");
    picker.options.forEach(function (option) { option.el.tabIndex = -1; });
    picker.typeahead = "";
    window.clearTimeout(picker.typeTimer);
    if (restoreFocus) picker.trigger.focus({ preventScroll: true });
    this.schedule();
  };
  Controls.prototype.closeFonts = function (restoreFocus) {
    this.fonts.forEach(function (picker) { this.closeFont(picker, restoreFocus); }, this);
  };
  Controls.prototype.fontKey = function (picker, event) {
    var key = event.key, index = picker.active;
    if (key === "Escape") { event.preventDefault(); this.closeFont(picker, true); return; }
    if (key === "Tab") {
      this.closeFont(picker, true);
      // Shift+Tab returns to the trigger; Tab continues to the next form control.
      if (event.shiftKey) event.preventDefault();
      return;
    }
    if (key === "Enter" || key === " ") {
      event.preventDefault();
      this.commit(picker.select, picker.options[index].font.key);
      this.closeFont(picker, true);
      return;
    }
    if (key === "ArrowDown") index += 1;
    else if (key === "ArrowUp") index -= 1;
    else if (key === "Home") index = 0;
    else if (key === "End") index = picker.options.length - 1;
    else if (key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
      window.clearTimeout(picker.typeTimer);
      picker.typeahead += fold(key);
      var search = picker.typeahead;
      if (Array.from(search).every(function (letter) { return letter === search[0]; })) search = search[0];
      for (var n = 1; n <= picker.options.length; n += 1) {
        var next = (picker.active + n) % picker.options.length;
        if (fold(picker.options[next].font.name).indexOf(search) === 0) { index = next; break; }
      }
      picker.typeTimer = window.setTimeout(function () { picker.typeahead = ""; }, 700);
    } else return;
    event.preventDefault();
    this.focusFont(picker, index);
  };

  Controls.prototype.makeColor = function (select, index) {
    var id = this.uid + "-color-" + index;
    var wrap = node("div", "fkc__color-picker");
    var group = node("div", "fkc__thread-swatches");
    var selected = node("p", "fkc__thread-selected");
    group.setAttribute("role", "radiogroup");
    group.classList.toggle("fkc__thread-swatches--names", this.settings.showColorNames === true);
    selected.setAttribute("role", "status");
    selected.setAttribute("aria-live", "polite");
    selected.setAttribute("aria-atomic", "true");
    var picker = { select: select, wrap: wrap, group: group, selected: selected, options: [] };
    this.i.colors.forEach(function (color, n) {
      var button = node("button", "fkc__thread-swatch");
      var face = node("span", "fkc__thread-face");
      var tick = node("span", "fkc__thread-tick");
      button.type = "button";
      button.id = id + "-option-" + n;
      button.dataset.fkcThreadChoice = color.key;
      button.title = color.name;
      button.setAttribute("role", "radio");
      button.setAttribute("aria-label", color.name);
      button.setAttribute("aria-checked", "false");
      button.tabIndex = -1;
      face.style.backgroundColor = color.fill;
      face.classList.toggle("fkc__thread-face--square", this.settings.swatchShape === "square");
      face.setAttribute("aria-hidden", "true");
      tick.appendChild(icon("check"));
      face.appendChild(tick);
      button.appendChild(face);
      if (this.settings.showColorNames === true) button.appendChild(node("span", "fkc__thread-name", color.name));
      group.appendChild(button);
      picker.options.push({ el: button, color: color });
    }, this);
    wrap.append(group, selected);
    var label = this.enhance(select, wrap, picker.options[0].el, id + "-label");
    picker.label = label;
    if (label) group.setAttribute("aria-labelledby", label.id); else group.setAttribute("aria-label", "Garnfarbe");
    this.colors.push(picker);
    this.listen(group, "click", function (event) {
      var button = event.target.closest("[data-fkc-thread-choice]");
      if (button && !button.disabled) this.commit(select, button.dataset.fkcThreadChoice);
    }.bind(this));
    this.listen(group, "keydown", function (event) {
      if (this.i.busy || select.disabled) return;
      var current = picker.options.findIndex(function (option) { return option.el === event.target; });
      if (current < 0) return;
      var next = current;
      if (event.key === "ArrowRight" || event.key === "ArrowDown") next += 1;
      else if (event.key === "ArrowLeft" || event.key === "ArrowUp") next -= 1;
      else if (event.key === "Home") next = 0;
      else if (event.key === "End") next = picker.options.length - 1;
      else return;
      event.preventDefault();
      next = (next + picker.options.length) % picker.options.length;
      this.commit(select, picker.options[next].color.key);
      picker.options[next].el.focus({ preventScroll: true });
    }.bind(this));
  };
  Controls.prototype.sync = function () {
    if (this.dead) return;
    this.fonts.forEach(function (picker) {
      var font = this.i.fonts.find(function (f) { return f.key === picker.select.value; }) || this.i.fonts[0];
      var sample = this.sample(picker.select.dataset.fkcTextKey);
      picker.name.textContent = font.name;
      picker.sample.textContent = sample;
      picker.sample.hidden = !sample;
      fontStyle(picker.name, font);
      fontStyle(picker.sample, font);
      picker.trigger.disabled = picker.select.disabled || this.i.busy;
      picker.options.forEach(function (option) {
        option.el.setAttribute("aria-selected", String(option.font.key === font.key));
        option.el.disabled = picker.trigger.disabled;
        option.sample.textContent = sample;
        option.sample.hidden = !sample;
      });
    }, this);
    this.colors.forEach(function (picker) {
      var selected = null;
      picker.options.forEach(function (option) {
        var active = option.color.key === picker.select.value;
        option.el.setAttribute("aria-checked", String(active));
        option.el.tabIndex = active ? 0 : -1;
        option.el.disabled = picker.select.disabled || this.i.busy;
        if (active) selected = option;
      }, this);
      var text = selected ? "Ausgewählt: " + selected.color.name : "";
      if (picker.selected.textContent !== text) picker.selected.textContent = text;
      if (picker.label && selected) picker.label.htmlFor = selected.el.id;
    }, this);
    this.schedule();
  };

  Controls.prototype.makeReturn = function () {
    if (this.settings.returnEnabled === false) return;
    var button = node("button", "fkc__preview-return");
    button.type = "button";
    button.dataset.fkcPreviewReturn = "";
    button.setAttribute("aria-label", this.settings.returnLabel || "Zur Live-Vorschau");
    button.title = this.settings.returnLabel || "Zur Live-Vorschau";
    button.setAttribute("aria-hidden", "true");
    button.tabIndex = -1;
    button.disabled = true;
    button.style.setProperty("--fkc-return-background", this.settings.returnBackground || "#202124");
    button.style.setProperty("--fkc-return-color", this.settings.returnColor || "#ffffff");
    button.style.setProperty("--fkc-return-size", number(this.settings.returnSize, 48, 44, 60) + "px");
    button.style.setProperty("--fkc-return-right", number(this.settings.returnRight, 16, 8, 40) + "px");
    button.appendChild(icon("up"));
    this.root.appendChild(button);
    this.returnButton = button;
    this.listen(button, "click", function () { this.returnToPreview(); }.bind(this));
  };
  Controls.prototype.headerBottom = function () {
    var viewport = window.visualViewport;
    var top = viewport ? viewport.offsetTop : 0;
    var height = viewport ? viewport.height : window.innerHeight;
    document.querySelectorAll("#header-component, #shopify-section-header, .section-header, sticky-header").forEach(function (header) {
      var rect = header.getBoundingClientRect();
      if (rect.top <= top + 1 && rect.bottom > top && rect.bottom < top + height / 3) top = Math.max(top, rect.bottom);
    });
    return top;
  };
  Controls.prototype.bindGeometry = function () {
    var schedule = this.schedule.bind(this);
    this.listen(window, "scroll", schedule, { passive: true });
    this.listen(window, "resize", schedule, { passive: true });
    this.listen(window, "pageshow", schedule);
    this.listen(window.visualViewport, "resize", schedule, { passive: true });
    this.listen(window.visualViewport, "scroll", schedule, { passive: true });
    this.listen(this.root, "transitionend", schedule);
    if (window.ResizeObserver) {
      var resize = new ResizeObserver(schedule);
      [this.root, this.i.elements.canvasWrap, this.i.elements.form.querySelector(".fkc__checkout")].forEach(function (el) { if (el) resize.observe(el); });
      this.observers.push(resize);
    }
    if (window.IntersectionObserver) {
      var intersection = new IntersectionObserver(schedule, { threshold: [0, 0.01, 1] });
      intersection.observe(this.i.elements.canvasWrap);
      intersection.observe(this.root);
      this.observers.push(intersection);
    }
    if (window.MutationObserver) {
      var state = new MutationObserver(schedule);
      state.observe(this.root, { attributes: true, attributeFilter: ["class", "data-fkc-ready"] });
      state.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
      this.observers.push(state);
    }
  };
  Controls.prototype.schedule = function () {
    if (this.dead || this.frame) return;
    this.frame = window.requestAnimationFrame(function () {
      this.frame = 0;
      if (!this.dead) this.updateReturn();
    }.bind(this));
  };
  Controls.prototype.updateReturn = function () {
    var overlay = this.root.classList.contains("is-tour-active") || document.documentElement.classList.contains("fkc-tour-open")
      || this.root.classList.contains("is-site-drawer-open")
      || Boolean(this.i.elements.zoomDialog && this.i.elements.zoomDialog.open);
    if (overlay) this.closeFonts(false);
    if (!this.returnButton) return;
    var viewport = window.visualViewport;
    var bottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
    var top = this.headerBottom();
    var canvas = this.i.elements.canvasWrap.getBoundingClientRect();
    var root = this.root.getBoundingClientRect();
    var hasOpenFont = this.fonts.some(function (picker) { return picker.open; });
    // "Am Seitenanfang lassen" is the static mode, including the customer's pin override.
    // The following preview already stays in view and must never create a second control.
    var show = this.root.dataset.fkcReady === "true" && !this.i.previewFollowsScroll()
      && (this.settings.returnScope !== "mobile" || this.i.mobilePreviewMedia.matches)
      && !overlay && !hasOpenFont && !this.i.busy && canvas.height > 0
      && canvas.bottom <= top - (this.returnVisible ? 0 : 8)
      && root.bottom > top + 80 && root.top < bottom;
    var checkout = this.i.elements.form.querySelector(".fkc__checkout");
    var button = this.returnButton;
    var size = number(this.settings.returnSize, 48, 44, 60);
    var gap = number(this.settings.returnGap, 12, 8, 32);
    var inset = number(this.settings.returnBottom, 16, 8, 160);
    var style = window.getComputedStyle(button);
    var right = parseFloat(style.right) || number(this.settings.returnRight, 16, 8, 40);
    var buttonLeft = window.innerWidth - right - size;
    if (checkout) {
      var cart = checkout.getBoundingClientRect();
      if (cart.height > 0 && cart.bottom > top && cart.top < bottom && cart.right > buttonLeft && cart.left < buttonLeft + size) {
        inset = Math.max(inset, bottom - cart.top + gap);
      }
    }
    var bottomOffset = Math.ceil(Math.max(0, window.innerHeight - bottom) + inset);
    var offset = bottomOffset + "px";
    if (button.style.getPropertyValue("--fkc-return-bottom") !== offset) button.style.setProperty("--fkc-return-bottom", offset);
    if (bottom - inset - size < top + 8) show = false;
    if (show !== this.returnVisible) {
      this.returnVisible = show;
      button.classList.toggle("is-visible", show);
      button.disabled = !show;
      button.tabIndex = show ? 0 : -1;
      button.setAttribute("aria-hidden", String(!show));
    }
  };
  Controls.prototype.returnToPreview = function () {
    var preview = this.i.elements.previewColumn;
    if (!preview || this.dead) return;
    this.closeFonts(false);
    var input = document.activeElement;
    if (input && /^(INPUT|TEXTAREA)$/.test(input.tagName)) input.blur();
    if (this.previewTabIndex === undefined) this.previewTabIndex = preview.getAttribute("tabindex");
    preview.tabIndex = -1;
    preview.focus({ preventScroll: true });
    var offset = this.headerBottom() + 12;
    var target = Math.max(0, preview.getBoundingClientRect().top + window.scrollY - offset);
    var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: target, left: window.scrollX, behavior: reduced ? "instant" : "smooth" });
  };
  Controls.prototype.destroy = function () {
    this.dead = true;
    if (this.frame) window.cancelAnimationFrame(this.frame);
    this.fonts.forEach(function (picker) { window.clearTimeout(picker.typeTimer); });
    this.observers.forEach(function (observer) { observer.disconnect(); });
    this.removers.slice().reverse().forEach(function (remove) { remove(); });
    if (this.returnButton) this.returnButton.remove();
    if (this.previewTabIndex !== undefined && this.i.elements.previewColumn) {
      if (this.previewTabIndex === null) this.i.elements.previewColumn.removeAttribute("tabindex");
      else this.i.elements.previewColumn.setAttribute("tabindex", this.previewTabIndex);
    }
    this.root.classList.remove("fkc--visual-choices");
  };
  window.FantastickConfiguratorControls = {
    version: VERSION,
    attach: function (instance) {
      if (instance.controlsUI) instance.controlsUI.sync();
      else instance.controlsUI = new Controls(instance);
      return instance.controlsUI;
    }
  };
})();
